seedWebApp.controller('DatabaseScriptsCtrl', ['$scope', 'DatabaseService', 'ToastService',
    function ($scope, DatabaseService, ToastService) {
        console.log('DatabaseScripts');

        $scope.tables = [
            { name: 'Contacts', isChecked: true, hasIdentity: false },
            { name: 'ContactDrawings', isChecked: true, hasIdentity: false },
            { name: 'SalesReps', isChecked: true, hasIdentity: false },

            { name: 'SalesOrders', isChecked: true, hasIdentity: false },
            { name: 'SalesOrderDetails', isChecked: true },
            { name: 'SalesOrderDocs', isChecked: true },
            { name: 'SalesOrderBoxes', isChecked: true },
            { name: 'SalesOrderRoutes', isChecked: true },
            { name: 'SalesOrderStatus', isChecked: true },
            

            { name: 'Materials', isChecked: true },
            { name: 'Refers', isChecked: true },
            { name: 'Drawings', isChecked: true },
            { name: 'Units', isChecked: true, hasIdentity: false },

            { name: 'ProcExps', isChecked: true },
            { name: 'Invoices', isChecked: true },

            { name: 'QuotationAdditionals', isChecked: true },

            { name: 'QuotationItems', isChecked: true },
            { name: 'QuotationLogistics', isChecked: true },
            { name: 'QuotationPeriods', isChecked: true },
            { name: 'QuotationPrices', isChecked: true },
            { name: 'QuotationRoutes', isChecked: true },

            { name: 'Routes', isChecked: true },
            { name: 'RoutePoints', isChecked: true },

            { name: 'ShipOwners', isChecked: true },
            { name: 'ShipOwnerCountries', isChecked: true },

            { name: 'Currencies', isChecked: true },

            { name: 'Emails', isChecked: true, hasIdentity: true },
            { name: 'EmailDocs', isChecked: true },
            { name: 'DocTypes', isChecked: true },

            { name: 'IntegrationGroups', isChecked: true },            
            { name: 'Integrations', isChecked: false },            
            { name: 'IntegrationTables', isChecked: false },

            //NOVOS
            { name: 'SentEmails', isChecked: true, hasIdentity: true },
            { name: 'SentEmailOrders', isChecked: true },

            { name: 'Stocks', isChecked: true },
            { name: 'Storages', isChecked: true },


            //STAGES
            //{ name: 'Stages', isChecked: true },
            //{ name: 'StageNexts', isChecked: true },
            //{ name: 'StageApprovals', isChecked: true },
            //{ name: 'StageApprovalUsers', checked: true },
            //{ name: 'StageFields', isChecked: true },
            //{ name: 'StageEmails', isChecked: true },


        ];

        $scope.checkAll = function () {
            $scope.setAll(true);
        };

        $scope.uncheckAll = function () {
            $scope.setAll(false);
        };

        $scope.setAll = function (enabled) {
            $scope.tables.forEach(function (table) {
                table.isChecked = enabled;
            })
        };

        $scope.generateScript = function () {
            console.log('generateScript: ' + $scope.tableName);

            $scope.sqlScript = '';
                DatabaseService.getCopyScripts($scope.tables).then(
                    function (response) {
                        //console.log(response);
                        $scope.sqlScript = response.data;                        
                    }, function (err) {
                        //console.log(err);
                        var errMsg = '';
                        if (err.data) {
                            errMsg = err.data.Message;
                            errMsg += '\n';
                            errMsg += '\n';
                            errMsg += err.data.ExceptionMessage;
                        }
                        $scope.sqlScript = 'ERRO API: ' + errMsg;
                    }
                );            
        };

        //$scope.generateScript = function () {
        //    console.log('generateScript: ' + $scope.tableName);
        //    $scope.sqlScript = '';
        //    for (var i = 0; i < $scope.tables.length; i++) {
        //        var table = $scope.tables[i];
        //        DatabaseService.getCopyScript(table.name).then(
        //            function (response) {
        //                //console.log(response);
        //                $scope.sqlScript += '\n';
        //                $scope.sqlScript += '\n---------------------------------';
        //                $scope.sqlScript += '\n-- SCRIPT TABELA ' + $scope.tables[i].name;
        //                $scope.sqlScript += '\n---------------------------------';
        //                $scope.sqlScript += '\n';
        //                $scope.sqlScript += response.data;
        //            }
        //        );
        //    }                        
        //};

    }
]
);
